import React, { useState } from 'react';
import './avatar.scss';
import { GECKO_UTILS, GeckoAvatarModel } from '../../';

const colorClasses = [
  'gecko-avatar-one',
  'gecko-avatar-two',
  'gecko-avatar-three',
  'gecko-avatar-four',
  'gecko-avatar-five',
  'gecko-avatar-six',
];

const GeckoAvatar = (props) => {
  const { bgImage, color, name, showInitials, size, title } = props;
  const [errored, setErrored] = useState(false);

  const handleError = () => setErrored(true);

  const getSizeClass = () => {
    if (size) return `gecko-avatar-${size}`;
    return null;
  };

  const getColorClass = () => {
    const FNV1_32A_INIT = 0x811c9dc5;
    let hval = FNV1_32A_INIT;
    for (let i = 0; i < name.length; ++i) {
      hval ^= name.charCodeAt(i);
      hval +=
        (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
    }
    return colorClasses[(hval >>> 0) % colorClasses.length];
  };

  const renderClass = (color = '') => {
    return GECKO_UTILS.classNames('gecko-avatar', getSizeClass(), color);
  };

  const renderInitials = () => {
    const names = name.split(' ').filter((name) => name !== '');
    if (!names.length) {
      return '';
    }
    if (names.length === 1) {
      return names[0][0].toUpperCase();
    }
    const first = names[0];
    const last = names[names.length - 1];
    return first[0].toUpperCase() + last[0].toUpperCase();
  };

  const renderStyles = () => {
    let styles = {};
    if (color) styles['backgroundColor'] = color;
    styles['color'] = getContrastColor(color);
    return styles;
  };

  const getContrastColor = (hexcolor) => {
    if (!hexcolor) return 'white';
    hexcolor =
      hexcolor.indexOf('#') > -1 ? hexcolor.replace('#', '') : hexcolor;
    let r = parseInt(hexcolor.substr(0, 2), 16);
    let g = parseInt(hexcolor.substr(2, 2), 16);
    let b = parseInt(hexcolor.substr(4, 2), 16);
    let yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 129 ? '#1a252f' : 'white';
  };

  return bgImage && !errored ? (
    <img
      title={title || name}
      alt={'avatar.png'}
      onError={handleError}
      className={renderClass(getColorClass())}
      src={bgImage}
    />
  ) : (
    <span
      title={title || name}
      className={renderClass(getColorClass())}
      style={renderStyles()}
    >
      {showInitials ? renderInitials() : name}
    </span>
  );
};

GeckoAvatar.defaultProps = {
  name: '',
  showInitials: true,
};

GeckoAvatar.propTypes = GeckoAvatarModel;

export default GeckoAvatar;
